import { z } from 'zod'

export const SubDomain = z.object({
  created: z.number().optional(),
  path: z.string(),
  php_version: z.string().optional(),
  name: z.string(),
  domain_id: z.number(),
  active: z.boolean()
})

export type SubDomain = z.infer<typeof SubDomain>
